<template>
  <div class="flex items-center px-4 h-[50px]" :class="{ 'bg-back-1': !isTransparent }">
    <div v-if="isBackButton" class="w-1/3 flex items-center cursor-pointer" @click="$router.back">
      <vIcon class="w-[22px] h-[22px] rotate-180" name="arrowChevron" />
      {{ $t("other|historyPage|back") }}
    </div>
    <div v-else class="w-1/3">
      <vIcon class="w-[22px] h-[22px]" name="circleClose" @click="WA.closeApp" />
    </div>
    <div class="text-center w-1/3">
      <div class="text-sm">{{ $t("other|historyPage|wallet") }}</div>
      <div class="text-xs text-text-4 leading-3">bot</div>
    </div>
    <!--     <div class="w-1/3 flex justify-end">
      <vIcon class="w-[22px] h-[22px]" name="circleMore" />
    </div> -->
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { computed } from "vue";
import vIcon from "@/components/ui/icon.vue";
import WA from "@/miniapp/tg";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();

const route = useRoute();

const isTransparent = computed(() => route.meta.transparentHeader === true);

const isBackButton = computed(() => {
  if (!userStore.isAuth) {
    return false;
  }

  if (route.meta.noBack) {
    return false;
  }
  if (!route.meta.topLevel) {
    return true;
  }
  return false;
});
</script>
